import {
  CREATE_PRODUCE,
  DELETE_PRODUCE,
  GET_ALL_PRODUCE,
  GET_BIDS_LIST,
  CREATE_BID,
  GET_PRODUCE,
  GET_PRODUCT_LIST,
  LOGOUT_SUCCESS,
  UPDATE_PRODUCE,
} from "../actions/actionTypes";

const initialState = {
  baseproducts: null,
  produce: null,
  bids: null,
  allProduce: null,
};

const farmReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PRODUCT_LIST: // all base products
      return {
        ...state,
        baseproducts: action.payload,
      };
    case GET_PRODUCE: // the farmer's produce
      return {
        ...state,
        produce: action.payload,
      };
    case GET_ALL_PRODUCE:
      return {
        ...state,
        allProduce: action.payload,
      };
    case CREATE_PRODUCE:
      return {
        ...state,
        produce: state?.produce?.concat(action.payload),
        allProduce: state?.allProduce?.concat(action.payload),
      };
    case UPDATE_PRODUCE:
      return {
        ...state,
        produce: state.produce.map((prod) =>
          prod.id === action.payload.id ? action.payload : prod
        ),
      };
    case DELETE_PRODUCE:
      return {
        ...state,
        produce: state.produce?.filter((prod) => prod.id !== action.payload),
        allProduce: state.allProduce?.filter(
          (prod) => prod.id !== action.payload
        ),
      };
    case GET_BIDS_LIST:
      return {
        ...state,
        bids: action.payload,
      };
    case CREATE_BID:
      return {
        ...state,
        bids: state.bids ? state.bids.concat(action.payload) : [action.payload],
      };
    case LOGOUT_SUCCESS:
      return initialState;
    default:
      return state;
  }
};

export default farmReducer;
